// extracted by mini-css-extract-plugin
export default {"root":"_11pgEpt6ynaotimcp0m9tL","header":"_3y_J_miykd8TvkldBWyBDy","cguContainer":"_2GzJW_gsuqOLL099LSykP5","text":"_3mJXjwdSK9adq0tfV0ZtJn"};